import { all, fork } from "redux-saga/effects"

//public
import AccountSaga from "./auth/register/saga"
import AuthSaga from "store/common/auth/login/saga"
import ForgetSaga from "./auth/forgetpwd/saga"
import ProfileSaga from "./auth/profile/saga"
import LayoutSaga from "./layout/saga"
import projectsSaga from "./projects/saga"
import tasksSaga from "./tasks/saga"
import productAdminAuthSaga from "store/ProductAdmin/login/saga"
import productAdminBirthChartSaga from "store/ProductAdmin/birthChartReport/saga"
import astroListingSaga from "store/ProductAdmin/UserManagement/saga"
import paymentsSaga from "store/payments/saga"

// Group - Reports
import grpReportsSaga from "store/group/reports/saga"
import grpProfileSaga from "store/group/profile/saga"
import grpSaga from "store/group/organisation/saga"
import grpDashboardSaga from "store/group/dashboard/saga"
import groupReportSaga from "store/auth/groupreport/saga"

export default function* rootSaga() {
  yield all([
    //public
    fork(AccountSaga),
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(ProfileSaga),
    fork(LayoutSaga),
    fork(projectsSaga),
    fork(tasksSaga),
    fork(productAdminAuthSaga),
    fork(productAdminBirthChartSaga),
    fork(astroListingSaga),
    fork(grpReportsSaga),
    fork(grpProfileSaga),
    fork(grpSaga),
    fork(grpDashboardSaga),
    fork(paymentsSaga),
    fork(groupReportSaga)
  ])
}
